import { useContext } from 'react';

import { DayModeAtmosphereContext, type DayModeAtmosphereValue } from './dayModeAtmosphereContext';

export function useDayModeAtmosphere(): DayModeAtmosphereValue {
  const value = useContext(DayModeAtmosphereContext);
  if (!value) {
    throw new Error('useDayModeAtmosphere must be used within a DayModeAtmosphereProvider');
  }
  return value;
}
